import ApiService from "@/services/Api"
import ErrorHandlerService from "@/services/ErrorHandler"
import { IChannel, IChat } from "@/protocols/channel"
import { ErrorType } from "@/hooks/useValidation"

export type ChatByProtocolIdResponse = {
	chat: IChat
	firstProtocolMessageId: string | null
}

class ChannelService {
	async setupChannels (instance_id: number): Promise<IChannel[] | null> {
		try {
			const response = await ApiService
				.get("/inbox/channel", {
					params: {
						instanceId: instance_id
					}
				})

			return response.data.inboxChannels
		} catch (error) {
			ErrorHandlerService.handle(error as ErrorType)
			return null
		}
	}

	async getChatByProtocolId (protocolId: number): Promise<ChatByProtocolIdResponse> {
		const { data } = await ApiService.get("/inbox/channel/chat/by-protocol-id", {
			params: { protocolId }
		})

		return data
	}
}

export default new ChannelService()
